import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=e3421ac6&"
import script from "./answer.vue?vue&type=script&lang=ts&"
export * from "./answer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports